export default {
    showFiltersButton: 'Vyhledat',
    showChargingStationFiltersButton: 'Vyhledávání',
    clearFiltersButton: 'Vymazat',

    serviceSelect: 'Zvolte požadovanou službu',
    serviceMaintenance: 'Servis',
    serviceTires: 'Pneu',
    serviceCallingAction: 'Svolávací akce',
    serviceChargingStations: 'Nabíjecí stanice',
    searchAddress: 'Vyhledat Adresu',
    searchAddressPlaceholder: 'Hledejte město, ulici nebo PSČ',
    searchAddressSelectNote: 'Prosíme vyberte adresu z nabídky.',
    searchArea: 'Hledat v okolí',

    minimumPower: 'Minimální výkon',
    all: 'Vše',
    operators: 'Provozovatelé',

    submitSearch: 'Vyhledat'
}
